import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data () {
    return {
      profissao: '',
      pagination: {},
      headers: [
        { text: 'Habilitar', align: 'center', sortable: false },
        { text: 'Descrição', align: 'left', sortable: false },
        { text: 'Ações', align: 'center', sortable: false }
      ],
      rowsPerPage: [10, 20, 30],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterRiskProfessions',
      'getterSelectedRiskProfessions'
    ])
  },
  watch: {
    pagination: {
      handler () {
        this.getAllRiskProfessions()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllRiskProfessions()
  },
  beforeDestroy () {
    this.CLEAR_RISK_PROFESSION_STORE()
  },
  methods: {
    ...mapActions([
      'actionGetAllRiskProfessions',
      'actionAddRiskProfession',
      'actionEditRiskProfession'
    ]),
    ...mapMutations([
      'SET_SELECTED_RISK_PROFESSION',
      'CLEAR_RISK_PROFESSION_STORE'
    ]),
    setSelectedRiskProfession (item) {
      this.SET_SELECTED_RISK_PROFESSION(item)
      this.profissao = item.profissaoOriginal
    },
    getAllRiskProfessions () {
      const params = {
        idClient: this.getterAccount.idClient,
        page: (this.pagination && this.pagination.page) ? this.pagination.page : 1,
        limit: this.pagination.rowsPerPage || this.rowsPerPage[0]
      }

      this.isLoading = true

      this.actionGetAllRiskProfessions(params)
        .then(() => {
          this.pagination.totalItems = this.getterRiskProfessions.totalResults

          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onClickMainButton () {
      if (Object.keys(this.getterSelectedRiskProfessions).length === 0) {
        this.addRiskProfession()
      } else {
        this.editRiskProfession()
      }
    },
    addRiskProfession () {
      const item = {
        idClient: this.getterAccount.idClient,
        profissaoOriginal: this.profissao,
        active: true
      }

      this.isLoading = true

      this.actionAddRiskProfession(item)
        .then(() => {
          this.cleanForm()

          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    editRiskProfession (item) {
      let updatedItem = {}
      const data = {
        profissaoOriginal: this.profissao
      }

      if (item) {
        updatedItem = {
          ...data,
          ...item
        }
      } else {
        updatedItem = {
          ...this.getterSelectedRiskProfessions,
          ...data
        }
      }

      this.actionEditRiskProfession(updatedItem)
        .then(() => {
          this.cleanForm()

          this.isLoading = false
        })
        .catch(() => {
          this.cleanForm()

          this.isLoading = false
        })
    },
    cleanForm () {
      this.profissao = ''
      this.SET_SELECTED_RISK_PROFESSION()
    }
  }
}
